import React from 'react';
import loadable from '@loadable/component';

type CreateSearchAlertModalProps = {
  onHidePopup?: () => void;
  triggerLocation?: string;
  triggerObject?: string;
};

const CreateSearchAlertModal = loadable(
  () =>
    import(
      /* webpackChunkName: "HeaderFooterTemplate.loadable" */ 'app/shared/modules/user-search/CreateSearchAlertModalComponent'
    ),
);

const LoadableCreateSearchAlertModal = (props: CreateSearchAlertModalProps) => {
  return <CreateSearchAlertModal {...props} />;
};

export default LoadableCreateSearchAlertModal;
